import React, { Component } from 'react';
import { Router, Route, Switch, Redirect, withRouter } from 'react-router-dom';
import { hot } from 'react-hot-loader';
import Finances from './finances';
import BusinessDetailsAll from './businessDetailsAll';
import AboutBusinessQuestion from './aboutBusinessQuestion';
import BusinessFinanceQuestion from './businessFinanceQuestion';
import BusinessContactDetailsQuestion from './businessContactDetailsQuestion';
import GDPRQuestion from './GDPRQuestion';
import TechnicalError from './common/technicalError';
import PropTypes from '../types';
import AppBootstrapComponent from './appBootstrap';
class ScrollToTop extends Component {
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    return this.props.children;
  }
}
const RouterScrollToTop = withRouter(ScrollToTop);

const Routes = ({ history }) => (
  <Router history={history}>
    <RouterScrollToTop>
      <Switch>
        <Redirect exact from="/" to="/startUp" />
        <Route path="/startUp" component={AppBootstrapComponent} />
        <Route path="/aboutBusiness" component={AboutBusinessQuestion} />
        <Route path="/finances" component={Finances} />
        <Route path="/businessFinance" component={BusinessFinanceQuestion} />
        <Route path="/businessContactDetails" component={BusinessContactDetailsQuestion} />
        <Route path="/gdpr" component={GDPRQuestion} />
        <Route path="/businessDetailsAll" component={BusinessDetailsAll} />
        <Route path="/technicalError" component={TechnicalError} />
      </Switch>
    </RouterScrollToTop>
  </Router>
);

Routes.propTypes = {
  history: PropTypes.shape({}).isRequired
};
export default hot(module)(Routes);
